import * as React from "react";
import { SiteSettings, Session, RecipientInformation, Country, Product } from "../types";
//import classNames from "classnames";
import t from "../i18n";
//import Img from "../controls/Img";
import Number from "../topup/Number";
import { Input } from "../Controls/Input";
import { Form, FormRef } from "@ajayvikas/react-fluent-validation";
import { recipientInfoValidator } from "./recipient-info-validator";
//import { ProductCategory } from "src/types-enums";

declare type RecipientProps = {
  siteSetting: SiteSettings;
  session: Session;
  recipientInfo: RecipientInformation | undefined;
  recipientChanged: (recipient: RecipientInformation) => void;
  country: Country | undefined;
  product: Product | undefined;
  countries: Country[];
  allCountries: Country[];
};

export default class RecipientInfoComponent extends React.Component<RecipientProps> {
  _recipientInfoForm: FormRef | null;
  // numberComp: NumberComp | null;
  // assignMobileNumRef = (ref: NumberComp | null) => {
  //     this.numberComp = ref;
  // }
  validate() {
    if (!this._recipientInfoForm) return false;
    const validationResult = this._recipientInfoForm.submit();
    const isValid = validationResult?.isValid() ?? false;
    return isValid;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    const recipient = this.props.recipientInfo;
    if (!recipient) return;
    this.props.recipientChanged({ ...recipient, ["recipientMobile"]: this.props.session.mobileNumber });
    this.props.session.recipientMobile= this.props.session.mobileNumber;
  }
  
  recipientChanged = (value: any, propertyName: keyof RecipientInformation) => {
    const recipient = this.props.recipientInfo;
    if (!recipient) return;
    this.props.recipientChanged({ ...recipient, [propertyName]: value });
    if(propertyName!="confirmRecipientEmail")
      this.props.session[propertyName]=value;    
  };

  render() {
    const recipient = this.props.recipientInfo || ({} as RecipientInformation);
    //populate details from session in case if repeat order or navigating between tabs
    if (!recipient) return;
    if(!recipient.recipientEmail){
      debugger;
      recipient.recipientMobile=this.props.session.recipientMobile;
      recipient.recipientEmail=this.props.session.recipientEmail;
      recipient.confirmRecipientEmail=this.props.session.recipientEmail;
      recipient.recipientFullName=this.props.session.recipientFullName;
      recipient.recipientMessage=this.props.session.recipientMessage;
      recipient.senderFullName=this.props.session.senderFullName;
    }
    const style = { paddingTop: 15, borderTopRightRadius: 0 };
    const stopCopyPaste = (e: any) => {
      e.preventDefault();
    };
    return (
      <div className="row">
        <div className="col-12" style={{ fontStyle: "italic", marginBottom: 10 }}>
          {t.topup("giftcard_delivery_disclaimer")}
        </div>
        <div className="col-12">
          <h5>{t.topup("enter_recipient_details")}</h5>
        </div>
        <Form ref={(f) => (this._recipientInfoForm = f)} object={recipient} validator={recipientInfoValidator}>
          <div className="block new-credit-card" style={style}>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group relative">
                  <h5>{t.topup("recipient_mobile")}</h5>
                  <Number
                    country={this.props.country}
                    product={this.props.product}
                    mobileNumber={(this.props.recipientInfo && this.props.recipientInfo.recipientMobile) || ""}
                    onMobileNumberChanged={(e) => this.recipientChanged(this.props.recipientInfo?.recipientMobile, "recipientMobile")}
                    countries={this.props.countries}
                    onCountrySelected={() => {}}
                    onDropdownChanged={() => {}}
                    showPlaceholder={false}
                    mobileBoxStyleCustom={{ height: 40 }}
                    focusOnMe={false}
                  />
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-group input-fa-group relative">
                  <h5>{t.topup("recipient_email")}</h5>
                  <Input
                    type="text"
                    maxLength={40}
                    className="form-control"
                    propertyName="recipientEmail"
                    value={recipient.recipientEmail || ""}
                    onChange={(e) => this.recipientChanged(e.target.value, "recipientEmail")}
                  />
                  <i className="icon fa fa-envelope-o fa-lg"></i>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-group input-fa-group relative">
                  <h5>{t.topup("confirm_recipient_email")}</h5>
                  <Input
                    type="text"
                    maxLength={40}
                    className="form-control"
                    propertyName="confirmRecipientEmail"
                    value={recipient.confirmRecipientEmail || ""}
                    onChange={(e) => this.recipientChanged(e.target.value, "confirmRecipientEmail")}
                    onCut={stopCopyPaste}
                    onCopy={stopCopyPaste}
                    onPaste={stopCopyPaste}
                  />
                  <i className="icon fa fa-envelope-o fa-lg"></i>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-group input-fa-group relative">
                  <h5>{t.topup("recipient_name")}</h5>
                  <Input
                    type="text"
                    maxLength={40}
                    className="form-control"
                    propertyName="recipientFullName"
                    value={recipient.recipientFullName || ""}
                    onChange={(e) => this.recipientChanged(e.target.value, "recipientFullName")}
                  />
                  <i className="icon fa fa-user-circle-o fa-lg"></i>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-group input-fa-group relative">
                  <h5>{t.topup("recipient_message")}</h5>
                  <Input
                    type="text"
                    maxLength={100}
                    className="form-control"
                    propertyName="recipientMessage"
                    value={recipient.recipientMessage || ""}
                    onChange={(e) => this.recipientChanged(e.target.value, "recipientMessage")}
                  />
                  <i className="icon fa fa-commenting-o fa-lg"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <h5>{t.topup("sender_details")}</h5>
          </div>
          <div className="block new-credit-card" style={style}>
          <div className="col-sm-12">
              <div className="form-group input-fa-group relative">
                <h5>{t.topup("sender_name")}</h5>
                <Input
                  type="text"
                  maxLength={40}
                  className="form-control"
                  propertyName="senderFullName"
                  value={recipient.senderFullName || ""}
                  onChange={(e) => this.recipientChanged(e.target.value, "senderFullName")}
                />
                <i className="icon fa fa-user-circle-o fa-lg"></i>
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}
